export default __webpack_public_path__ + "static/media/question-solid.90ca0bd2.png";